import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
} from "../../common_nextgen/utils/Constants";
import {
  useLocationState,
  useReceiveExternalMessages,
} from "../../common_nextgen/common_components/common-hooks/useLocationState";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "./AdjustmentReasonCodeListFormConfig";

const screenInfo = {
  ADD: ["Add Adjustment Reason Code List", "RCAD1003"],
  CHANGE: ["Adjustment Reason Code List Detail", "RCAD1002"],
  VIEW: ["Adjustment Reason Code List Detail", "RCAD1002"],
};

const AdjustmentReasonCodeListForm = ({ mode }) => {
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  /*const { state: stateVal } = location;
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);*/
  const { currentState, previousState, setStateVal } = useLocationState({
    initialState: location.state || [],
  });
  let {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.ADJUSTMENT_REASON_CODE_LIST,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    externalScreenNumber = null,
    externalScreenTitle = null,
  } = currentState;
  console.log("current state in form", currentState, previousState);
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  useReceiveExternalMessages(setStateVal, setExternalMode);
  const toast = useToast();

  const lastScheduleName =
    selectedSchedules[currentIndex]?.ad1AdjReasonCodeList || "";
  const updatedParamsData = {
    ...currentState.paramsData,
    ad1AdjReasonCodeList: lastScheduleName,
  };
  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setInitialFormData({});
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, [
        ...previousState,
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
      ]);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>-</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitFormData = (data) => {
    setDataForSubmission(data);
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";

    if (isAddMode(currentMode)) {
      url = "api/ad1AdjReasonCodeList";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/ad1AdjReasonCodeList";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        toast.current.show({
          severity: "info",
          summary: "",
          detail: "No Change of Information",
          life: 3000,
        });
        return;
      }
    }

    const data = { ...dataForSubmission, screenNumber };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      setInitialFormData(responseData);
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const latestCurrentState = {
          ...currentState,
          selectedSchedules: [{ ...responseData }],
          currentIndex: 0,
          externalMode,
        };
        const updatedState = [...previousState, latestCurrentState];
        setStateVal(updatedState);
        navigateToPage(
          ROUTE_PATHS.ADJUSTMENT_REASON_CODE_LIST_EDIT,
          updatedState
        );
      }
    } catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
      keyFunc.F7 = () =>
        navigateToPage(ROUTE_PATHS.CODES_IN_ADJUSTMENT_REASON_CODE_LIST, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSchedules: [initialFormData],
            previousScreen: location.pathname,
            currentIndex: 0,
            externalScreenNumber,
            externalScreenTitle,
          },
        ]);
      keyName.F7 = "Adjustment Reason Codes";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F7 = () =>
        navigateToPage(ROUTE_PATHS.CODES_IN_ADJUSTMENT_REASON_CODE_LIST, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSchedules: [selectedSchedules[currentIndex]],
            previousScreen: location.pathname,
            currentIndex: 0,
            externalScreenNumber,
            externalScreenTitle,
          },
        ]);
      keyName.F7 = "Adjustment Reason Codes";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, previousState, currentState, initialFormData]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const url = isAddMode(currentMode)
        ? `api/ad1AdjReasonCodeList/initialFormData/${encodeURIComponent(
            screenInfo.ADD[1]
          )}`
        : `api/ad1AdjReasonCodeList/${encodeURIComponent(
            selectedSchedules[currentIndex]?.ad1AdjReasonCodeList
          )}`;
      const { responseData } = await axios_helper_no_header("GET", url);
      setInitialFormData(responseData);
    };

    if (
      (isAddMode(currentMode) || selectedSchedules.length) &&
      !Object.keys(initialFormData).length
    )
      fetchInitialData();
  }, [mode, currentIndex, selectedSchedules, initialFormData]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default AdjustmentReasonCodeListForm;
